import { AuthGuard } from './shared/guards/auth.guard';
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ContentComponent } from "./shared/components/layout/content/content.component";
import { FullComponent } from "./shared/components/layout/full/full.component";
import { full } from "./shared/routes/full.routes";
import { content } from "./shared/routes/routes";
import { AuthComponent } from './components/auth/auth.component';

const routes: Routes = [
  {
    path: "",
    redirectTo: "ecommerce/products",
    pathMatch: "full",
  },
  {
    path: 'login',
    component: AuthComponent,
  },
  {
    path: "",
    component: ContentComponent,
    children: content,
  },
  {
    path: "",
    component: FullComponent,
    children: full
  },
  {
    path: "**",
    redirectTo: "ecommerce/products",
  },
];

@NgModule({
  imports: [
    [
      RouterModule.forRoot(routes, {
        anchorScrolling: "enabled",
        scrollPositionRestoration: "enabled",
      }),
    ],
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
